import { PromptCategoryId } from "@shaarp/common";

export type PromptCategory = {
  id: PromptCategoryId;
  name: string;
  description: string;
};

export const PROMPT_CATEGORIES: PromptCategory[] = [
  {
    id: "targeting",
    name: "Ciblage & ICP",
    description:
      "Définir le profil idéal de clients, segments prioritaires et critères de qualification.",
  },
  {
    id: "brief",
    name: "Brief entreprise 360°",
    description:
      "Résumer une entreprise, comprendre son contexte et préparer un échange.",
  },
  {
    id: "signals",
    name: "Signaux d'opportunité",
    description:
      "Identifier les signaux qui montrent un besoin et trouver le bon moment pour contacter.",
  },
  {
    id: "approach",
    name: "Plan d'approche",
    description:
      "Choisir le bon canal, planifier les étapes et préparer les accroches.",
  },
  {
    id: "writing",
    name: "Rédaction 1:1",
    description:
      "Rédiger des emails, messages LinkedIn et scripts d'appels personnalisés.",
  },
  {
    id: "qualification",
    name: "Qualification & suivi",
    description:
      "Qualifier les opportunités, gérer les objections et suivre les prochaines étapes.",
  },
  {
    id: "other",
    name: "Autres",
    description: "Prompts qui ne correspondent à aucune autre catégorie.",
  },
];

export const PROMPT_CATEGORY_IDS: PromptCategoryId[] = PROMPT_CATEGORIES.map(
  (c) => c.id,
);

export const getCategoryById = (id: PromptCategoryId): PromptCategory | undefined => {
  return PROMPT_CATEGORIES.find((category) => category.id === id);
};

export const getCategoryName = (id: PromptCategoryId): string => {
  return getCategoryById(id)?.name || "Autres";
};

export const getCategoryDescription = (id: PromptCategoryId): string => {
  return getCategoryById(id)?.description || "";
};
